import { TextField, MenuItem } from "@mui/material";

const SeveritySelectFieldForObjectState = ({
  formInfo,
  Object,
  handleChange,
}) => {
  const inputProps = {
    style: {
      backgroundColor: "white",
      textAlign: "left",
      color: "black", // Set the font color to black
    },
  };

  const inputLabelProps = {
    style: {
      fontSize: "1.2rem", // Increase the font size of the label
      color: "black", // Set the label color to black
    },
    shrink: true,
  };

  let label = Object.label;
  let name = Object.name;

  let AboveText = Object.AboveText;

  return (
    <>
      {window.innerWidth >= 800 ? (
        <div style={{ fontSize: "1.2rem", color: "black" }}>{AboveText}</div>
      ) : (
        <div style={{ fontSize: "1.2rem", color: "black" }}>
          {AboveText}
          <br></br>
          <i>{label}:</i>
        </div>
      )}
      <div className="textFieldContainer">
        <TextField
          label={window.innerWidth >= 800 ? label : ""}
          name={name}
          value={formInfo[name] || ""}
          onChange={handleChange}
          variant="outlined"
          // helperText={
          //   <div className="text-left">
          //     • Red – the student is likely to require urgent or life-saving
          //     treatment should they become unwell or the condition (such as an
          //     allergy) be triggered.
          //     <br></br>• Amber – the student may require urgent care but can
          //     generally manage their symptoms if they become unwell or the
          //     condition (such as asthma) is triggered.
          //     <br></br>• Green – the student is unlikely to require support from
          //     a healthcare provider should they become unwell, they might
          //     require over-the-counter medicines from InvestIN staff but can
          //     manage their symptoms well.
          //     <br></br>• Blue – this is for information only. The student is
          //     very unlikely to need any support with this and symptoms are
          //     minor; therefore, unlikely to impact their learning or residential
          //     experience.
          //   </div>
          // }
          fullWidth
          InputProps={inputProps}
          InputLabelProps={inputLabelProps}
          select
        >
          <MenuItem value="">-----</MenuItem>
          <MenuItem
            key={"Red"}
            value={"Red"}
            title="Please see top of the page for description"
          >
            <span style={{ color: "red", fontSize: "1.5rem" }}>⬤</span>
            {"Red"}
          </MenuItem>
          <MenuItem
            key={"Amber"}
            value={"Amber"}
            title="Please see top of the page for description"
          >
            <span style={{ color: "#FFBF00", fontSize: "1.5rem" }}>⬤</span>
            {"Amber"}
          </MenuItem>
          <MenuItem
            key={"Green"}
            value={"Green"}
            title="Please see top of the page for description"
          >
            <span style={{ color: "Green", fontSize: "1.5rem" }}>⬤</span>
            {"Green"}
          </MenuItem>
          <MenuItem
            key={"Blue"}
            value={"Blue"}
            title="Please see top of the page for description"
          >
            <span style={{ color: "Blue", fontSize: "1.5rem" }}>⬤</span>
            {"Blue"}
          </MenuItem>
        </TextField>
      </div>
    </>
  );
};

export default SeveritySelectFieldForObjectState;
